import { SPACE, THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { CssSelectors, Layouts, cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	scheduleDateNotice: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		marginTop: SPACE[8],
		paddingLeft: SPACE[20],
		paddingRight: SPACE[20],
	},
	// The RegEd questionnaire runs long enough to push the submit button past the viewport, so the
	// form scrolls inside the dialog rather than the dialog growing past it.
	reviseDialogForm: {
		maxHeight: '60vh',
		minHeight: 0,
		overflowY: 'auto',
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
		justifyContent: 'center',
	},
	approvalActions: {
		alignItems: 'stretch',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
	},
	actionsVertical: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		...Layouts.verticalStack(SPACE[12]),
		...CssSelectors.allChildren(
			{
				marginRight: 0,
			},
			'button'
		),
	},
	approvalStatusTitle: {
		color: THEME.colors.warning.main,
		fontSize: THEME.typography.fontSizes.sm,
		textAlign: 'left',
		textTransform: 'uppercase',
	},
	approvedStatusDate: {
		alignItems: 'flex-end',
		fontSize: THEME.typography.fontSizes.sm,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	approvedStatusTitle: {
		color: THEME.colors.success.main,
		fontSize: THEME.typography.fontSizes.sm,
		textAlign: 'left',
		textTransform: 'uppercase',
	},
	buttonActions: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: SPACE[12],
		...CssSelectors.allChildren(
			{
				fontSize: THEME.typography.fontSizes.sm,
			},
			'button'
		),
	},
	cancelButton: {
		flex: 1,
	},
	cancelInstructions: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		marginTop: SPACE[20],
		padding: SPACE[16],
	},
	timelineCard: {
		marginTop: SPACE[20],
	},
	cardActions: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				fontSize: THEME.typography.fontSizes.sm,
			},
			'button'
		),
	},
	cardTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		margin: `0 0 ${SPACE[8]}px`,
	},
	scheduleDateActions: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		...CssSelectors.allChildren(
			{
				fontSize: THEME.typography.fontSizes.sm,
			},
			'button'
		),
	},
	container: {
		...Layouts.verticalStack(SPACE[20]),
		overflowY: 'auto',
	},
	complianceButtons: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		marginTop: SPACE[12],
		...CssSelectors.allChildren(
			{
				fontSize: THEME.typography.fontSizes.sm,
				marginBottom: SPACE[8],
			},
			'button'
		),
	},
	// Zero the link buttons' horizontal padding so their envelope icons sit flush with the card's left edge,
	// lining up with the "Compliance Approval" title and "Pending Approval" status above them. The Button's
	// size styles set padding under a `:has(> svg)` selector, so we must override at the same specificity.
	complianceLinkButton: {
		paddingLeft: 0,
		paddingRight: 0,
		':has(> svg)': {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	complianceIcon: {
		marginRight: SPACE[8],
	},
	complianceInputGroup: {
		// The InputGroup is a `div`, not a `button`, so `complianceButtons`' `> button` spacing rule does not
		// reach it — give the row its own bottom gap to match the surrounding link buttons.
		marginBottom: SPACE[8],
		maxWidth: 320,
	},
	previewContentTitle: {
		fontSize: THEME.typography.fontSizes.md,
	},
	recipientsCard: {
		fontSize: THEME.typography.fontSizes.sm,
	},
	sideHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	socialContainer: {
		...Layouts.verticalStack(SPACE[20]),
	},
	tagList: {
		marginTop: SPACE[16],
	},
});
